/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, RootStateOrAny } from 'react-redux'

import CheckboxAntd from 'Containers/ui/CheckboxAntd'
// @ts-ignore
import ChristmasIcon from 'Shared/icons/christmas.svg'

import { MoodName, Mood } from '../../../Types'

import * as S from './styles'
import { MoodsProps } from './props'

export const MoodsComponent = ({
  moodTooltipShown,
  mobile,
  isCampaign,
  moodsChecked,
  setMoodsChecked,
}: MoodsProps) => {
  const { t } = useTranslation()

  const allMoods: Array<Mood> = useSelector(
    (state: RootStateOrAny) => state.moods.moods
  )

  const isArtist = useSelector((state: RootStateOrAny) => state.auth.isArtist)
  const user = useSelector((state: RootStateOrAny) => state.auth.user)
  const isAuth = !!Object.keys(user).length

  const renderMoodLabel = (moodName: MoodName) => {
    switch (moodName) {
      case MoodName.christmas:
        return isArtist || !isAuth
          ? t('scheduleCampaignPage.christmasMoodOptionCampaign')
          : t('scheduleCampaignPage.christmasMoodOption')
      default:
        return ''
    }
  }

  const handleMoodSet = (id: number) => {
    if (moodsChecked.includes(id)) {
      setMoodsChecked(moodsChecked.filter(el => el !== id))
    } else {
      setMoodsChecked([...moodsChecked, id])
    }
  }

  // TODO map in separate function

  return (
    // @ts-ignore
    <S.MoodsWrapper mobile={mobile} isCampaign={isCampaign}>
      <S.MoodsTitle>
        <div>{t('scheduleCampaignPage.additionalSettings')}</div>
      </S.MoodsTitle>
      <div>
        {!moodTooltipShown && (
          // @ts-ignore
          <S.ChristmasTooltip mobile={mobile}>
            <img src={ChristmasIcon} alt="" />
            <span>{t('scheduleCampaignPage.newSettingsPopup')}</span>
          </S.ChristmasTooltip>
        )}
        {allMoods.map(el => (
          <S.MoodsCheckbox key={el.mood_name}>
            <CheckboxAntd
              checked={moodsChecked.includes(el.id)}
              onChange={() => handleMoodSet(el.id)}
            />
            <S.MoodsCheckboxLabel>
              {renderMoodLabel(el.mood_name)}
            </S.MoodsCheckboxLabel>
          </S.MoodsCheckbox>
        ))}
      </div>
    </S.MoodsWrapper>
  )
}
